import { Component, ElementRef, inject, input, InputSignal, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { Log } from '../../models/log';
import { LogService } from '../../services/log.service';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Psychologist } from '../../models/psychologists';
import { UsersSharingLogsComponent } from "../users-sharing-logs/users-sharing-logs.component";
import { LoadingComponent } from '../loading/loading.component';
import TYPES from '../../constants/types';

@Component({
  selector: 'app-list',
  imports: [
    DatePipe,
    TranslatePipe,
    UsersSharingLogsComponent,
    LoadingComponent
],
  templateUrl: './list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './list.component.scss'
})
export class ListComponent{
  authService: AuthService = inject(AUTH_SERVICE);
  logService: LogService<Log> = inject(LogService);
  
  yourMindLogIsActive:InputSignal<boolean> = input<boolean>(true);
  sharedWithYouIsActive:InputSignal<boolean> = input<boolean>(false);
  listLogs: InputSignal<Log[] | undefined> = input();
  listShared: InputSignal<any[] | undefined> = input();
  psychologist: InputSignal<Psychologist | undefined> = input();
  loadingLogs: InputSignal<boolean> = input(false);
  loadingSharedLogs: InputSignal<boolean> = input(false);
  filterBy: InputSignal<string> = input('');

  userSelected = output<string>();

  logsAnchor = viewChild<ElementRef>('logsScrollAnchor');
  logsSharedAnchor = viewChild<ElementRef>('logsSharedScrollAnchor');

  moods:any = TYPES.APPLICATION.MOODS;

  constructor(private router: Router){}

  getMoodColor(mood:string | null = ''){
    switch(mood){
      case 'moods.super_positive':{
        return 'super-positive';
      }
      case 'moods.positive':{
        return 'positive';
      }
      case 'moods.neutral':{
        return 'neutral';
      }
      case 'moods.negative':{
        return 'negative';
      }
      case 'moods.super_negative':{
        return 'super-negative';
      }
      default:{
        return '';
      }
    }
  }

  getMood(label:string|null){
    return this.moods.filter(
      (item:any) => {
        return item.label === label;
      }
    )[0];
  }

  getPercentage(log: Log){
    if(log.other_thought){
      return '100%';
    }else if(log.did_think){
      return '86%';
    }else if(log.did_do){
      return '71%';
    }else if(log.what_happened){
      return '57%';
    }else if(log.body_reactions){
      return '43%';
    }else if(log.feelings){
      return '29%';
    }else{
      return '14%';
    }
  }

  editLog(log:Log){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.logService.log.set(log);
    this.logService.canAccessMindLogRegister.set(true);
    this.router.navigate(['/mood']);
  }

  viewLog(item:any){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    const log: any = {
      id: item.logs.id,
      user_id: item.logs.user_id,
      mood: item.logs.mood,
      feelings: item.logs.feelings,
      body_reactions: item.logs.body_reactions,
      what_happened: item.logs.what_happened,
      did_do: item.logs.did_do,
      did_think: item.logs.did_think,
      other_thought: item.logs.other_thought,
      created_at: item.logs.created_at,
      updated_at: item.logs.updated_at,
    }

    this.logService.log.set(log);

    this.router.navigate(['/log-viewer'], {
      queryParams: { data: JSON.stringify(item.users.first_name+' '+item.users.last_name) } 
    });
  }

  filterByUser(userId:any){
    this.userSelected.emit(userId);
  }
}
